import { useGetAccounts } from '@vindr/services/actions/account.action';
import { DefinedColumns } from '@vindr/services/interfaces';
import { useTranslation } from 'react-i18next';
import { FetchColumn } from './FetchColumn';

const creatorColumn = <T,>(props?: Partial<DefinedColumns<T>>): DefinedColumns<T> => {
  const { t } = useTranslation('Vindoc');

  const {
    title,
    dataIndex = 'creator_id' as keyof T,
    width = 50,
    key = 'creator_id' as keyof T,
    ellipsis = true,
    ...rest
  } = props || {};

  return {
    title: title || t('Creator'),
    dataIndex,
    width,
    key,
    ellipsis,
    // render: (id) => <RowComp text={id} />,
    render: (id) => (
      <FetchColumn
        queryFn={useGetAccounts}
        defaultParams={{ limit: 10, offset: 0 }}
        queryParams={{ ids: [id] }}
        searchParams={{ id }}
        renderItem={(creator) => creator?.fullname || creator?.username || '-'}
      />
    ),
    ...rest,
  };
};

export default creatorColumn;
